export default __webpack_public_path__ + "5990d1adef13e890ce0a1781bbc396c3.svg";